import { ajax } from 'linksoft';

$(document).on('click', '#reload-resources', function () {
  ajax({ url: '/api/Localization/Reload', method: 'POST' })
      .done(result => {
          window.location.reload();            
      })
      .fail(result => {
          console.log('Reloading of resources cache failed!');
      });
})


// WEBPACK FOOTER //
// ./App/containers/translations.js